export const menuItems = [
  {
    icon: "ri-function-line",
    selectedIcon: "ri-function-fill",
    name: "leftNavigationMenu.dashboard",
    menu: "dashboard",
    link: "/dashboard",
  },
  {
    icon: "ri-box-3-line",
    selectedIcon: "ri-box-3-fill",
    name: "leftNavigationMenu.products",
    menu: "products",
    link: "/products",
  },
  {
    icon: "ri-survey-line",
    selectedIcon: "ri-survey-fill",
    name: "leftNavigationMenu.orders",
    menu: "orders",
    link: "/orders",
  },
  {
    icon: "ri-receipt-line",
    selectedIcon: "ri-receipt-fill",
    name: "leftNavigationMenu.invoices",
    menu: "invoices",
    link: "/invoices",
    roles: ["InvoiceViewer"]
  },
  {
    icon: "ri-truck-line",
    selectedIcon: "ri-truck-fill",
    name: "leftNavigationMenu.deliveries",
    menu: "deliveries",
    link: "/deliveries",
  },
];

export const toolMenuItems = [
  {
    icon: "ri-rocket-line",
    selectedIcon: "ri-rocket-fill",
    name: "leftNavigationMenu.templates",
    menu: "templates",
    link: "/templates",
  },
  {
    icon: "ri-calculator-line",
    selectedIcon: "ri-calculator-fill",
    name: "leftNavigationMenu.estimates",
    menu: "estimates",
    link: "/estimator",
    roles: ["OrderingViewer"],
  },
  {
    icon: "ri-bill-line",
    selectedIcon: "ri-bill-fill",
    name: "leftNavigationMenu.quotes",
    menu: "quotes-list",
    link: "/quotes-list",
  },
  {
    icon: "ri-home-8-line",
    selectedIcon: "ri-home-8-fill",
    name: "leftNavigationMenu.propertyReports",
    menu: "property-reports",
    link: "/property-reports",
  },
  {
    icon: "ri-percent-line",
    selectedIcon: "ri-percent-fill",
    name: "leftNavigationMenu.lending",
    menu: "lending",
    link: "/lending",
    featureFlag: "enableGoodleapFeature",
    customerRoles: [], // 1 = Owner/Executive - see story 113325
    showForDemo: true, // Always show for DEMO001 accounts
    disallowLoginAs: true
  },
  {
    icon: "ri-layout-grid-2-line",
    selectedIcon: "ri-layout-grid-2-fill",
    name: "leftNavigationMenu.solar",
    menu: "solar",
    link: "/solar",
  },
  {
    icon: "ri-sun-line",
    selectedIcon: "ri-sun-fill",
    name: "leftNavigationMenu.weather",
    menu: "weather",
    submenu: [
      {
        icon: "ri-corner-down-right-line",
        name: "leftNavigationMenu.weatherMap",
        menu: "weather-map",
        link: "/weather-coming",
      },
      {
        featureFlag: "enableWeatherAlertsFeature",
        icon: "ri-corner-down-right-line",
        name: "leftNavigationMenu.weatherReports",
        menu: "weather-reports",
        link: "/weather-reports",
      },
      {
        featureFlag: "enableWeatherAlertsFeature",
        icon: "ri-corner-down-right-line",
        name: "leftNavigationMenu.weatherSettings",
        menu: "weather-settings",
        link: "/weather-settings",
      },
    ],
  },
  {
    icon: "ri-puzzle-2-line",
    selectedIcon: "ri-puzzle-2-fill",
    name: "leftNavigationMenu.integrations",
    menu: "integrations",
    link: "/integrations",
  },
  {
    icon: "ri-bar-chart-2-line",
    selectedIcon: "ri-bar-chart-2-fill",
    name: "leftNavigationMenu.analytic",
    menu: "analytic",
    link: "/analytics",
    roles: ['QBRPreview', 'ShowCustomerRebateTracker']
  },
  {
    icon: "ri-gift-line",
    selectedIcon: "ri-gift-fill",
    name: "leftNavigationMenu.promosRewards",
    menu: "supplier-promotions",
    submenu: [
      {
        icon: "ri-corner-down-right-line",
        name: "leftNavigationMenu.manufacturerRewards",
        menu: "manufacturer-rewards",
        link: "/supplier-promotions?tab=manufacturerRewards",
      },
      {
        icon: "ri-corner-down-right-line",
        name: "leftNavigationMenu.offers",
        menu: "offers",
        link: "/supplier-promotions?tab=offers",
        featureFlag: "promotionsEnabled"
      },
    ],
  },
  {
    icon: "ri-map-pin-line",
    selectedIcon: "ri-map-pin-fill",
    name: "leftNavigationMenu.locations",
    menu: "locations",
    link: "/locations",
   },
   {
    icon: "ri-file-chart-line",
    selectedIcon: "ri-file-chart-fill",
    name: "leftNavigationMenu.leads",
    menu: "leads",
    link: "/leads",
   }
];

export const userProfile = [
  {
    icon: "ri-settings-5-line",
    name: "leftNavigationMenu.profileSettings",
    menu: "profile-settings",
    link: "/profile/details",
  },
  {
    icon: "ri-team-line",
    name: "leftNavigationMenu.users",
    menu: "users",
    link: "/profile/registered-user-list",
  },
  {
    icon: "ri-lock-password-line",
    name: "leftNavigationMenu.changePassword",
    menu: "change-password",
    link: "/profile/change-password",
  },
  {
    icon: "ri-arrow-left-right-line",
    name: "leftNavigationMenu.switchAccount",
    menu: "switch-account",
    link: "/SwitchAccount",
  },
  {
    icon: "ri-logout-circle-r-line",
    name: "leftNavigationMenu.logout",
    menu: "logout",
    link: "/logout",
  },
];
